import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug } from '../../../../utils';

export const BNK_STMT_getBanks_API_CALL = createAsyncThunk(
  'BNK_STMT_getBanks_API_CALL',
  async (payload, { getState, rejectWithValue, dispatch }) => {
    dispatch({ type: 'BNK_STMT_getBanks_API_CALL/pending', payload: {} });
    const {
      getBankAPIPayload,
      successFn = () => {},
      errorFn = () => {},
      finallyFn,
    } = payload;
    const { customerId, Authorization, customerRefNum, source, agentId } =
      getBankAPIPayload;
    SecureClient({
      isEncrypted: true,
      customerId: customerId,
      route: 'customerkyc/getbank',
      payload: {
        customerRefNum,
        source,
        agentId,
      },
      otherPayloadDetailsPresent: true,
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const bankInfoDetails = res && res.body && res.body.bankInfoDetails;
        dispatch({
          type: 'BNK_STMT_getBanks_API_CALL/fulfilled',
          payload: bankInfoDetails,
        });
        if (successFn) successFn(bankInfoDetails);
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({
          type: 'BNK_STMT_getBanks_API_CALL/rejected',
          payload: err,
        });
        if (errorFn) errorFn(err);
      },
      finallyFn,
    });
  }
);

export const BNK_STMT_getBanks_API_CALL_extrareducer = {
  [BNK_STMT_getBanks_API_CALL.pending]: (state, action) => {
    state.getBankAPICall.isLoading = true;
  },
  [BNK_STMT_getBanks_API_CALL.fulfilled]: (state, action) => {
    state.getBankAPICall.isLoading = false;
    state.getBankAPICall.isSuccess = true;
    state.getBankAPICall.isError = false;
    state.getBankAPICall.response = action.payload;
  },
  [BNK_STMT_getBanks_API_CALL.rejected]: (state, action) => {
    state.getBankAPICall.isLoading = false;
    state.getBankAPICall.isSuccess = false;
    state.getBankAPICall.isError = true;
    state.getBankAPICall.response = action.payload;
  },
};
